import Env from '@opsbase/lib-env';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useEmailAppDownloadLink from '@opsbase/react-gql-hooks/staff/useEmailAppDownloadLink';
import markdown from '@opsbase/react-markdown';
import useCss from '@opsbase/web-css';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import TextField from '@opsbase/web-textfield/TextField';
import Button from '@opsbase/web-ui/Button';
import Text from '@opsbase/web-ui/Text';
import * as React from 'react';
import { useState } from 'react';
import appstoreLogo from '../../../../shared/assets/images/app-store-download.svg';
import googleplayLogo from '../../../../shared/assets/images/play-store-download.png';
const makeMyClasses = () => ({
    root: {
        backgroundColor: Palette.White.main,
    },
});
const styles = {
    image1: {
        height: 50,
        aspectRatio: '1',
        cursor: 'pointer',
    },
    image2: {
        height: 72,
        aspectRatio: '1',
        cursor: 'pointer',
    },
};
export function DownloadApp(props) {
    const { email, name } = props;
    const [emailAddress, setEmail] = useState(email);
    const { raise } = useNotificationActions();
    const emailAppDownloadLink = useEmailAppDownloadLink();
    const myCss = useCss(makeMyClasses);
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress);
    const sendEmail = async () => {
        return raise(emailAppDownloadLink({
            email,
            name,
        }), i18n.t('download-app-link-sent'));
    };
    return (React.createElement(Vertical, { gutter: true, paddingX: true },
        React.createElement(Text, { variant: 'h1' }, i18n.t('download-app')),
        React.createElement(Text, null, i18n.t('download-app-line1')),
        React.createElement(Text, null, markdown(i18n.t('download-app-line2'))),
        React.createElement(Text, null, i18n.t('download-app-line3')),
        React.createElement(Horizontal, { gutter: true, centered: true },
            React.createElement(TextField, { autoFocus: true, className: myCss.root, value: emailAddress, onChange: setEmail, fullWidth: true }),
            React.createElement("div", null,
                React.createElement(Button, { disabled: !isEmailValid, onClick: sendEmail }, i18n.t('send-link')))),
        React.createElement(Horizontal, { centered: true, justify: 'flex-start', gutter: true },
            React.createElement("img", { alt: "", style: styles.image1, src: appstoreLogo, onClick: () => window.open(Env.appStoreUrl) }),
            React.createElement("img", { alt: "", style: styles.image2, src: googleplayLogo, onClick: () => window.open(Env.playStoreUrl) })),
        React.createElement(Text, null, i18n.t('download-app-line4')),
        React.createElement(Text, null, i18n.t('download-app-line5'))));
}
export default DownloadApp;
